/**
 * Allow only same-origin relative paths for post-login redirects.
 * Rejects protocol-relative (`//evil.com`) and absolute URLs.
 */
export function safeInternalPath(value: unknown): string | undefined {
  if (typeof value !== "string" || value.length === 0) {
    return undefined;
  }

  if (!value.startsWith("/") || value.startsWith("//")) {
    return undefined;
  }

  return value;
}

/** Wallet setup is enforced by the authenticated guard — never a login return target. */
const POST_LOGIN_EXCLUDED_PATHS: readonly string[] = ["/user/wallet-setup"];

/**
 * Same-origin post-login path, or undefined so login falls through to the dashboard.
 * Drops wallet-setup even if it was preserved as `?redirect=` after logout.
 */
export function resolvePostLoginPath(value: unknown): string | undefined {
  const path = safeInternalPath(value);
  if (!path) return undefined;

  const pathname = path.split(/[?#]/)[0];
  if (POST_LOGIN_EXCLUDED_PATHS.includes(pathname)) return undefined;

  return path;
}
